// extracted by mini-css-extract-plugin
module.exports = {"pageTldr":"index-module--pageTldr--2jAlT","pageTldrRibbon":"index-module--pageTldrRibbon--WFCaQ"};